// extracted by mini-css-extract-plugin
export default {"preview":"AnimationGallery_preview__FS3g1","background":"AnimationGallery_background__zrT8C","wrap":"AnimationGallery_wrap__ttJMN"};